import { render, staticRenderFns } from "./info-block.vue?vue&type=template&id=b58d04f2&scoped=true"
import script from "./info-block.vue?vue&type=script&lang=js"
export * from "./info-block.vue?vue&type=script&lang=js"
import style0 from "./info-block.vue?vue&type=style&index=0&id=b58d04f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58d04f2",
  null
  
)

export default component.exports